<template>
  
    <div >
      <packagesisps
        :isloading="isLoading"
        :activepackagesisps="activePackagesIsps"
        :archivedpackagesisps="archivedPackagesIsps"
        :unregisteredpackagesisps="unregisteredPackagesIsps"
        :speedprofiles="speedProfiles"
        :filterspeeds="filterSpeeds"
        :packagesispcats="packagesIspCats"
        :packagesisptemplates="packagesIspTemplates"
        :locationnetworks="locationNetworks"
        :packagetypes="['Residential', 'Business','Other']"
        :organisations="organisations"
        @packagesIspsSaved="initialize();"
        @groupTemplateChange="updateGroupTemplate()"
      ></packagesisps>
    </div>

</template>
      <!-- ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
<script>
import Api from "@/services/Api";
import format from "date-fns/format";

import PackagesIsps from '@/components/PackagesIsps.vue';
import ActivePackagesIsps from '@/components/PackagesIsps.vue';
import ArchivedPackagesIsps from '@/components/PackagesIsps.vue';
import UnregisteredPackagesIsps from '@/components/PackagesIsps.vue';
import LocationNetworks from '@/components/PackagesIsps.vue';
export default {
    
  components: {
    packagesisps: PackagesIsps,
    activepackagesisps: ActivePackagesIsps,
    archivedpackagesisps: ArchivedPackagesIsps,
    unregisteredpackagesisps: UnregisteredPackagesIsps,
    locationnetworks: LocationNetworks

  },
  data() {
    return {
      LocationNetworksLocations: [],
      speedProfiles:[],
      packagesIsp:[],
      packagesIspCats:[],
      packagesIspTemplates:[],
    activePackagesIsps:[],
    archivedPackagesIsps: [],
    unregisteredPackagesIsps: [],
    initialActivePackagesIsps:[],
    initialArchivedPackagesIsps: [],
    initialUnregisteredPackagesIsps: [],
    customerId:[],
    filterSpeeds:[],
    isLoading: true,
    locationNetworks: [],
    organisations: []
    };
  },
  computed: {},
  async created() {
    let route = await this.$store.state.currentOrg.org.permissions.filter(function(el){
        return el.url === '/packagesIsps'})
      if (route.length > 0) {
      await this.$store.dispatch("setCurrentRoute", route[0]);
      if (this.authRead(this.$store.state.currentRoute) === true) {
        this.initialize();
      }
    } else {
      this.$router.push({ name: "SplashPage" });
    }
  },
  watch: {
    activepackagesisps: ()=> {
      this.activepackagesisps = fetchLocations();
    },
    '$route.query':{
      immediate: true,
      async handler(value){
        this.isLoading=true
        
        if(typeof value.locationNetworkId ==='undefined'){
          value.locationNetworkId=null
        } 
        if(typeof value.customerId ==='undefined'){
          value.customerId=null
        }
        if(typeof value.speedProfileId ==='undefined'){
          value.speedProfileId=null
        }
        if(typeof value.packageType ==='undefined'){
          value.packageType=null
        }
      
        let customerId=value.customerId
        let locationNetworkId = value.locationNetworkId
        let speedProfileId = value.speedProfileId
        let packageType=value.packageType
        
        
        
        
        if(value.currentTab==='activePackages'){
          
          this.activePackagesIsps=this.initialActivePackagesIsps
          
          if(customerId!==null){
            this.activePackagesIsps= await this.activePackagesIsps.filter(function(el){
              return el.customerOrganisationId ===customerId
            })
          }
          if(locationNetworkId!==null){
            this.activePackagesIsps=await this.activePackagesIsps.filter(function(el){
              return el.locationNetworkId ===locationNetworkId
            })
          }
          if(speedProfileId!==null){
            this.activePackagesIsps=await this.activePackagesIsps.filter(function(el){
              return el.packagesFno.speedProfile.downloadMbps ===speedProfileId
            })
          }
          if(packageType!==null){
            this.activePackagesIsps=await this.activePackagesIsps.filter(function(el){
              return el.packagesFno.packagesFnoCat.packageCatType ===packageType
            })
          }
        }

        if(value.currentTab==='unregisteredPackages'){
          this.unregisteredPackagesIsps=this.initialUnregisteredPackagesIsps
          
          if(customerId!==null){
            this.unregisteredPackagesIsps= await this.unregisteredPackagesIsps.filter(function(el){
              return el.customerOrganisationId ===customerId
            })
          }
          if(locationNetworkId!==null){
            this.unregisteredPackagesIsps=await this.unregisteredPackagesIsps.filter(function(el){
              return el.locationNetworkId ===locationNetworkId
            })
          }
          if(speedProfileId!==null){
            this.unregisteredPackagesIsps=await this.unregisteredPackagesIsps.filter(function(el){
              return el.packagesFno.speedProfile.downloadMbps ===speedProfileId
            })
          }
          if(packageType!==null){
            this.unregisteredPackagesIsps=await this.unregisteredPackagesIsps.filter(function(el){
              return el.packagesFno.packagesFnoCat.packageCatType ===packageType
            })
          }
        }
        this.isLoading=false
        }
       
  }},

  methods: {
    fetchOrganisations() {
      this.isLoading =true
      Api()
        .get("/organisation/basic")
        .then(response => {
          this.organisations = response.data;
              this.isLoading =false
        });
    },
  async refreshIspPackages(){
        this.isLoading=true
        
        if(typeof this.$route.query.locationNetworkId ==='undefined'){
          this.$route.query.locationNetworkId=null
        } 
        if(typeof this.$route.query.customerId ==='undefined'){
          this.$route.query.customerId=null
        }
        if(typeof this.$route.query.speedProfileId ==='undefined'){
          this.$route.query.speedProfileId=null
        }
        if(typeof this.$route.query.packageType ==='undefined'){
          this.$route.query.packageType=null
        }
        let customerId=this.$route.query.customerId
        let locationNetworkId = this.$route.query.locationNetworkId
        let speedProfileId = this.$route.query.speedProfileId
        let packageType=this.$route.query.packageType
        if(this.$route.currentTab==='activePackages'){
          this.activePackagesIsps=this.initialActivePackagesIsps
          if(customerId!==null){
            this.activePackagesIsps= await this.activePackagesIsps.filter(function(el){
              return el.customerOrganisationId ===customerId
            })
          }
          if(locationNetworkId!==null){
            this.activePackagesIsps=await this.activePackagesIsps.filter(function(el){
              return el.locationNetworkId ===locationNetworkId
            })
          }
          if(speedProfileId!==null){
            this.activePackagesIsps=await this.activePackagesIsps.filter(function(el){
              return el.packagesFno.speedProfileId ===speedProfileId
            })
          }
          if(packageType!==null){
            this.activePackagesIsps=await this.activePackagesIsps.filter(function(el){
              return el.packagesFno.packagesFnoCat ===packageType
            })
          }
        }

        if(this.$route.currentTab==='unregisteredPackages'){
          this.unregisteredPackagesIsps=this.initialUnregisteredPackagesIsps
          if(customerId!==null){
            this.unregisteredPackagesIsps= await this.unregisteredPackagesIsps.filter(function(el){
              return el.customerOrganisationId ===customerId
            })
          }
          if(locationNetworkId!==null){
            this.unregisteredPackagesIsps=await this.unregisteredPackagesIsps.filter(function(el){
              return el.locationNetworkId ===locationNetworkId
            })
          }
          if(speedProfileId!==null){
            this.unregisteredPackagesIsps=await this.unregisteredPackagesIsps.filter(function(el){
              return el.packagesFno.speedProfileId ===speedProfileId
            })
          }
          if(packageType!==null){
            this.unregisteredPackagesIsps=await this.unregisteredPackagesIsps.filter(function(el){
              return el.packagesFno.packagesFnoCat ===packageType
            })
          }
        }
        
    //       if(this.$route.query.locationNetworkId!==null&&this.$route.query.speedProfileId!==null&&this.$route.query.packageType!==null){

            
         
    // }
    },
      fetchAllPackagesIsps() {
        this.isLoading=true
      Api()
        .get("/supplier/packagesIsps/basic/active")
        .then(response => {
          this.activePackagesIsps = response.data;
          this.initialActivePackagesIsps=response.data
          this.isLoading=false
        });
        Api()
        .get("/supplier/packagesIsps/basic/unregistered")
        .then(response => {
          this.unregisteredPackagesIsps = response.data;
          this.initialUnregisteredPackagesIsps=response.data
          this.isLoading=false
        });},
    async fetchPackagesIsps(ispId) {
      this.isLoading=true
      await Api()
        .get("/supplier/packagesIsps/basic/active/"+ispId)
        .then(response => {
          this.activePackagesIsps = response.data;
          this.initialActivePackagesIsps=response.data
          this.isLoading=false;
        });
        let locationNetworkId=[]
        this.locationNetworks=[]
        await Api()
        .get("/supplier/packagesIsps/basic/unregistered/"+ispId)
        .then(response => {
          this.unregisteredPackagesIsps = response.data;
          this.initialUnregisteredPackagesIsps=response.data
          this.isLoading=false
        });
        for(let i =0;i<this.activePackagesIsps.length;i++){
          if(!locationNetworkId.includes(this.activePackagesIsps[i].locationNetworkId)){
            locationNetworkId.push(this.activePackagesIsps[i].locationNetworkId)
            this.locationNetworks.push(this.activePackagesIsps[i].locationNetwork)
          }
        }
        for(let i =0;i<this.unregisteredPackagesIsps.length;i++){
          if(!locationNetworkId.includes(this.unregisteredPackagesIsps[i].locationNetworkId)){
            locationNetworkId.push(this.unregisteredPackagesIsps[i].locationNetworkId)
            this.locationNetworks.push(this.unregisteredPackagesIsps[i].locationNetwork)
          }
        }
        this.locationNetworks.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0)); 
        },
        fetchAllLocationNetworks(){
      Api()
        .get("/locationNetworks/basic/active")
        .then(response => {
          this.locationNetworks = response.data;
          this.isLoading=false
        });
        },
        fetchSpeedProfiles(){
          this.filterSpeeds=[]
          Api()
          .get('/speedprofiles')
          .then(response=>{
            this.speedProfiles=response.data
            for(let i=0;i<this.speedProfiles.length;i++){
              if(!this.filterSpeeds.includes(this.speedProfiles[i].downloadMbps)){
                this.filterSpeeds.push(this.speedProfiles[i].downloadMbps)
              }
            }
            this.filterSpeeds.sort((a, b) => a - b);
          })
        },
    fetchLocations(){
      Api()
        .get("/Locations/active")
        .then(response => {
          this.LocationNetworksLocations = response.data;
        })
    },
    fetchPackagesIspCats(){
      Api()
      .get('/packagesIspCats')
      .then(response=>{
        this.packagesIspCats=response.data
      })
    },
    fetchPackagesIspTemplate(){
      Api()
      .get('/packagesIspTemplate')
      .then(response=>{
        this.packagesIspTemplates=response.data
      })
    },
    fetchPackagesIspCatsByCustomer(ispId){
      Api()
      .get('/packagesIspCats/byCustomer/'+ispId)
      .then(response=>{
        this.packagesIspCats=response.data
      })
    },
    fetchPackagesIspTemplateByCustomer(ispId){
      Api()
      .get('/packagesIspTemplate/byCustomer/'+ispId)
      .then(response=>{
        this.packagesIspTemplates=response.data
      })
    },
    updateGroupTemplate(){
          this.fetchPackagesIspCats();
          this.fetchPackagesIspTemplate()
    },
    initialize() {
          this.fetchAllPackagesIsps();
          this.fetchAllLocationNetworks();
          this.fetchSpeedProfiles();
          this.fetchPackagesIspCats();
          this.fetchPackagesIspTemplate()
      
    }
  }
};
</script>
